import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BookingService, TravelService } from '../../api/services';
import { AuthService } from '../services/auth.service';
import { map } from 'rxjs';

export const userAccessGuard: CanActivateFn = (route, state) => {
  const bookingService = inject(BookingService);
  const authService = inject(AuthService);
  const router = inject(Router);

  const myId = authService.user.value?.id;
  const bookingIdentifier = route.params['identifier'];
  if (!myId) {
    return router.createUrlTree(['/']);
  }

  return bookingService
    .bookingControllerGetBooking({ booking_identifier: bookingIdentifier })
    .pipe(
      map((res) => {
        const booking = res.data;

        //  Controllo  è la mia prenotazione?
        const isMyBooking = booking.created_by_user?.id === myId;

        return isMyBooking ? true : router.createUrlTree(['/']);
      }),
    );
};
